import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=623926f7&scoped=true&"
import script from "./personalCard.vue?vue&type=script&lang=js&"
export * from "./personalCard.vue?vue&type=script&lang=js&"
import style0 from "./personalCard.vue?vue&type=style&index=0&id=623926f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623926f7",
  null
  
)

export default component.exports